import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Header from "../../components/global/Header";
import Intro from "../../components/academy/Intro";
import Lectors from "../../components/Lectors";
import Newsletter from "../../components/Newsletter";
import Workwithus from "../../components/academy/Workwithus";
import Vision from "../../components/academy/Vision";
import Loopingpromo from "../../components/global/Loopingpromo";
import Stats from "../../components/academy/Stats";
import AdoptSkill from "../../components/academy/AdoptSkill";
import Products from "../../components/global/Products";
import Footer from "../../components/global/Footer";
import Istqb from "../../components/global/Istqb";
import Testimonials from "../../components/global/Testimonials";
import TeamBanner from "../../components/global/TeamBanner";
import AboutUs from "../../components/academy/AboutUs";
import ScrollToTopButton from "../../components/global/ScrollToTop";
import FormKontaktGlobal from "../../components/global/FormKontaktGlobal";
import { useLocation } from "react-router-dom";
import ButtonFinancovanie from "../../components/global/ButtonFinancovanie";
import PromoPopUpV2 from "../../components/global/promoPopUp/PromoPopUpV2";
import ModalOverlay from "../../components/global/ModalOverlay";
import {usePromoPopUpHelper} from "../../components/global/promoPopUp/usePromoPopUpHelper";

const Academy = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // promo pop-up handling
    const usePopUp = true; // true to activate popup
    const [showPromoPopUp, setShowPromoPopUp] = useState(false);
    const {handlePromoPopUp} = usePromoPopUpHelper();

  const [openContactForm, setContactForm] = useState(false);
  const handleClick = (e) => {
    if (e.target.id === "bg") {
        setContactForm(false);
        setShowPromoPopUp(false);
    }
  }

  useEffect(() => {
      if (usePopUp) {
          handlePromoPopUp(setShowPromoPopUp);
      }

    // Update the window width when the component mounts
    setWindowWidth(window.innerWidth);

    // Add event listener to update the window width on resize
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const threshold = 200; // Adjust this value as needed

      if (scrollPosition > threshold) {
        setShowContent(true);
      } else {
        setShowContent(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function renderPopupWindow() {
      if (openContactForm) {
          return <FormKontaktGlobal setContactForm={setContactForm} />
      } else if (showPromoPopUp) {
          return <PromoPopUpV2 setShowPromoPopUp={setShowPromoPopUp} />
      } else return;
  }

  return (
    <Box>
      {showContent && windowWidth > 1100 && <ButtonFinancovanie />}
      <Header />
      {/* intro */}
      <Intro />
      {/* Scroll to top */}
      <ScrollToTopButton />
      {/* looping promotion */}
      <Loopingpromo />
      {/* stats */}
      {windowWidth > 500 ? <Stats /> : null}
      {/* form contact */}
      {(openContactForm || (showPromoPopUp && windowWidth < 600)) && (
          <ModalOverlay handleClick={handleClick}>
              { renderPopupWindow() }
          </ModalOverlay>
      )}

      {/* products */}
      <Products setContactForm={setContactForm} windowWidth={windowWidth} />
      {/* ISTQB */}
      <Istqb />
      {windowWidth <= 500 ? <Stats /> : null}
      {/* ADOPT ANOTHER SKILL */}
      <AdoptSkill />
      {/* accredited and skilled */}
      <Testimonials />
      {/* our team banner */}
      <TeamBanner />
      {/* lectors */}
      <Box
        sx={{
          backgroundColor: "#1b144a",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Lectors itemsPerPage={1}></Lectors>
      </Box>

      {/* about us */}
      <AboutUs setContactForm={setContactForm} />
      {/* our vision */}
      <Vision />
      {/* work with us */}
      <Workwithus />
      {/* newsletter subscription */}
      <Newsletter />
      <Footer setContactForm={setContactForm} />
    </Box>
  );
};

export default Academy;
